import {useRef} from "react";
import useBgColorStore from "../../stores/bgColorStore";

const WrapperBg = ({children}) => {

    const sectionRef = useRef()
    const { currentColorClass } = useBgColorStore();


    return (
        <main className={`${currentColorClass} w-full transition-colors duration-500`} ref={sectionRef}>
            {children}
        </main>
    );
};

export default WrapperBg;